import React from 'react'
import styled from "styled-components";

const CardStyle = styled.div `

.card {
  transform-style: preserve-3d;
  transition: transform 0.5s linear;
  width: 283px;
  height: 380px;
}

.card-box {
  width: auto;
  height: auto;
}

.front, .back {
  
  width:95%;
  height: 95%;
  backface-visibility: hidden;
  
}

.back{
  transform: rotateY(180deg);
  align-text:center;
}

.card-box:hover .card {
  transform: rotateY(180deg);
}

.h1 {
  background-color: black;
}

@media (max-width: 615px) {
  .card {
    width: 220px;
    height:20rem;
    minHeight: 320px,
  } 

  .card-box {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 450px) {
  .card {
    width: 190px;
    height:20rem;
    minHeight: 320px,
  } 

  .card-box {
    width: 100%;
    height: 100%;
  }
}

`


function FullBgFlipcard({flipcard}) {

  const TITLE_OVERLAY = {
    background: "linear-gradient(rgba(0,0,0,0) 20%, rgba(0,0,0,0.9))",
  }
  
  const BACKGROUND_IMAGE = {
    backgroundImage: `url(${flipcard.image})`,
    backgroundSize: "cover"
  }

  return (
    <div className="">
      <CardStyle>
      <div className="card-box">
        <div className='relative card flex flex-col text-center justify-center'>
          <div className="front absolute transform shadow rounded-lg bg-white flex flex-col justify-between">
            <div className="w-full h-full overflow-hidden relative rounded-lg" style={BACKGROUND_IMAGE}>
              <div className="w-full h-40 absolute bottom-0 flex flex-col justify-end" style={TITLE_OVERLAY}>
                <h1 className="text-lg pb-6 px-0.5 text-white object-bottom">{flipcard.title}</h1>
              </div>
            </div>
          </div>
          <div className="back flex flex-col absolute shadow rounded-lg bg-form border-b-4 border-primary">
            <div className="back-content my-auto p-2 sm:p-6 text-left transform ">
              <h1 className="text-lpGray font-semibold">{flipcard.title}</h1>
              <p className="text-xs md:text-sm text-gray-800 pt-4">{flipcard.content}</p>
            </div>
          </div>
        </div>
      </div>
      </CardStyle>
    </div>
    
  )
}

export default FullBgFlipcard
